import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';


type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

type ThisProjectMessages = {
    step: {
        personalInfo: {
            teacherStatus: {
                administrator: string,
                academic: string,
            },
        },
    },
};

export const messagesEN: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    status: 'Select employee type',
    emailAddress: 'School-issued email address',
    infoShared1: 'Information entered here will be used for verification purposes only.',
    infoShared2: ' ',
    privacyPolicy: ' ',
    verifyMyTeacherStatus: 'Verify my status',
    step: {
        personalInfo: {
            title: 'Verify your eligibility for special Higher Education products and pricing',
            subtitle: "Verify you're an employee from an eligible institution.",
            teacherStatus: {
                academic: 'Academic',
                administrator: 'Administrator',
            },
        },
        success: {
            subtitle: 'We verified your eligibility',
            verificationOnly: "SheerID handles verification only. Now that you've been approved you can continue to the buy page online. Verification is good for 12 months and will be saved to your Esri login.",
            redirectButtonText: 'Continue',
        },
        docUpload: {
            title: 'We need more information',
            submitButtonLabel: 'Submit',
            uploadInstructions: 'Upload your school-issued document that shows:',
            acceptableUploads: {
                teacher: {
                    idCard: 'Employer ID card with valid date',
                },
            },
        },
        pending: {
            titleReview: 'Processing',
            titleCountdown: 'Processing',
            subtitle: 'SheerID is reviewing your documents to confirm your status.<br><br>This process may take up to 20 minutes.',
        },
    },
};
